
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { agentInstanceService } from '../../services/agentService';
import PostSignupModal from '../PostSignupModal';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAuth = true,
  redirectTo = '/login',
}) => {
  const { isAuthenticated, isLoading, user, fetchProfileAndSaveToken } = useAuth();
  const location = useLocation();

  const [showPostSignupModal, setShowPostSignupModal] = useState(false);
  // const [categoryOptions, setCategoryOptions] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    if (user?.user && !user.user.tenantId) {
      setShowPostSignupModal(true);
    } else {
      setShowPostSignupModal(false);
    }
  }, [user]);

  useEffect(() => {
    let cancelled = false;  
    const token = typeof window !== "undefined"
    ? localStorage.getItem("agentic_auth_token")
    : null;
  

    (async () => {
      if(!token && !showPostSignupModal){
        return
      }
    })();

    return () => { cancelled = true; };
  }, [showPostSignupModal]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-agentic-white-off flex items-center justify-center">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4"></div>
          <p className="text-agentic-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (requireAuth && !isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (!requireAuth && isAuthenticated) {
    const from = (location.state as any)?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  return (
    <>
      {children}

      <PostSignupModal
        isOpen={showPostSignupModal}
        categoryOptions={[]}
        onSuccess={(resp?: any) => {
          setShowPostSignupModal(false);
          // Use the new session (token now carries the tenant) when the server returned one.
          fetchProfileAndSaveToken(resp?.token ? { token: resp.token, refreshToken: resp.refreshToken } : undefined);
        }}
        showCloseButton={false}
      />
    </>
  );
};

export default ProtectedRoute;
